import { render } from "./Assets.vue?vue&type=template&id=5348e8c4"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=5348e8c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__